import { render, staticRenderFns } from "./OptionsItem.vue?vue&type=template&id=59fcfc64&scoped=true&"
import script from "./OptionsItem.vue?vue&type=script&lang=js&"
export * from "./OptionsItem.vue?vue&type=script&lang=js&"
import style0 from "./OptionsItem.vue?vue&type=style&index=0&id=59fcfc64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fcfc64",
  null
  
)

export default component.exports